import { colors } from '@lamimed/pantheon';
import { css } from 'styled-components';

import { ThemeProps } from 'hooks/useWidgetStyles';

export const scrollbarTheme = (theme: ThemeProps) => css`
  scrollbar-color: ${theme.primaryColor} ${colors.light};
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 0.5rem;
    height: 5rem;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.primaryColor};
    border-radius: 0.5rem;
  }
`;
